import {FC} from 'react'
import { formatVerificationStatus } from '../../../../../../../utils/streamlineSpecificHelpers'

type Props = {
  status?: string
}

const VerificationStatus: FC<Props> = ({status}) => {

  const s = formatVerificationStatus(status)
  return (
    <>
      <div className={`badge py-2 px-4 fs-8 ${s.pillClass}`}>
        { s.label }
      </div>
    </>
  )
}

export {VerificationStatus}